import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav style={{ display: 'flex', gap: 16, padding: 16 }} aria-label="Main navigation">
      <Link to="/">{t('app_name')}</Link>
      {user && (user.role === 'premium' || user.role === 'admin') && <Link to="/premium">{t('premium')}</Link>}
      {user && user.role === 'admin' && <Link to="/admin">{t('admin_panel')}</Link>}
      {user && <Link to="/profile">{t('profile')}</Link>}
      {user && <Link to="/totp">{t('totp_codes')}</Link>}
      {user && (user.role === 'premium' || user.role === 'admin') && <Link to="/sync">{t('sync')}</Link>}
      {!user && <Link to="/login">{t('login')}</Link>}
      {!user && <Link to="/register">{t('register')}</Link>}
      {user && <button onClick={handleLogout} aria-label={t('logout')}>{t('logout')}</button>}
      {user && <span style={{ marginLeft: 16 }}>({user.email} - {t(user.role)})</span>}
    </nav>
  );
};

export default Navbar; 